/*
 * Returns a primevue icon class for any given mimeType.
 */
import {
  EMimeType,
} from '@/types/mime.ts';

export function getFileIcon(mimeType: EMimeType | string | null | undefined): string {
  switch (mimeType) {
    case EMimeType.PDF:
      return 'pi pi-file-pdf';
    case EMimeType.CSV:
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'pi pi-file-excel';
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'pi pi-file-word';
    default:
      if (mimeType?.startsWith('image/')) {
        return 'pi pi-image';
      }
      return 'pi pi-file';
  }
}
